import React from 'react';

/**
 * LoadingSpinner Component
 * 
 * Simple loading indicator for Suspense fallbacks and async operations
 */
function LoadingSpinner() {
  return (
    <div 
      className="d-flex justify-content-center align-items-center" 
      style={{ 
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999
      }}
    >
      <div 
        className="spinner-border" 
        role="status"
        style={{ 
          width: '3rem', 
          height: '3rem',
          borderColor: '#24292E',
          borderRightColor: 'transparent'
        }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}

export default LoadingSpinner;
